// Front end javascript file
// you might want to have everything within one of these bad boys:
// window.addEventListener('load', (event) => { --> code here <-- });

window.addEventListener('load', (event) => {

 // Adds animations to all the images
 // at widths less than 992, when images are all centred
 // only the fade up animation is used
 // over 992, the animation varies with the 
 // image's alignment
 let screenWidth = window.innerWidth;

 let articles            = document.querySelectorAll(".wp-block-jcc-content-article");

// This code is causing all images to face up and then dissapear on page load
// Fix is before reenabling

// The reason images aren't animating as expected is due to AOS scanning the page and finding nothing
// THEN our animatiable elements are being added to the page, but AOS is unaware of them
// can use AOS.refresh(); or AOS.refreshHard(); to try and fix this, but havent got the time
// to fully trouble shoot it now.


 // articles.forEach((article) => {
 //  let articleImages      = article.querySelectorAll(".wp-block-image");
 //  let articleImagesLeft  = article.querySelectorAll(".wp-block-image.alignleft");
 //  let articleImagesRight = article.querySelectorAll(".wp-block-image.alignright");
 
 //  if (screenWidth <= 991) {
 //   articleImages.forEach((image) => {
 //    image.setAttribute("data-aos", "fade-up");
 //   });
 //  } else {
 //   articleImages.forEach((image) => {
 //    image.setAttribute("data-aos", "fade-up");
 //   });
  
 //   articleImagesLeft.forEach((image) => {
 //    image.setAttribute("data-aos", "fade-right");
 //   });
  
 //   articleImagesRight.forEach((image) => {
 //    image.setAttribute("data-aos", "fade-left");
 //   });
 //  } 
 // });



});